import { isPlatformBrowser } from '@angular/common';
import {  ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { Subject, takeUntil } from 'rxjs';
@Component({
    selector: 'clever-travelclass',
    templateUrl: './travelclass.component.html',
    styleUrls: ['./travelclass.component.scss'],
    standalone: false
})
export class TravelclassComponent implements OnInit, OnDestroy {
    protected unsubscribe$ = new Subject();
    @Input() mode: string;
    isBrowser: boolean = false;
    currentTravelClass: string = '';

    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected hotelService: HotelFiltersService,
        protected cdr: ChangeDetectorRef
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initFilterSub();
        }
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    selectTravelClass(klass): void {
        if (this.currentTravelClass === klass) {
            this.currentTravelClass = '';
        } else {
            this.currentTravelClass = klass;
        }
        this.hotelService.travelClass(this.currentTravelClass, this.mode !== 'home');
    }

    initFilterSub(): void {
        this.hotelService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: ParamFilters) => {
            this.currentTravelClass = filter.flight?.travelClass;
            this.cdr.markForCheck();
        });
    }
}
